import { defineComponent as _defineComponent } from 'vue'
import { LinkItem } from '@cnamts/vue-dot/src/patterns/FooterBar/types';

	
export default /*#__PURE__*/_defineComponent({
  __name: 'app-footer',
  setup(__props) {

	const linkItems: LinkItem[] = [
		{
			text: 'Mentions légales et CGU',
			to: {
				name: window.URL_LEGAL_NOTICES
			}
		},
		{
			text: 'Gestion des cookies',
			to: {
				name: window.URL_LEGAL_NOTICES,
				hash: window.URL_CGU_COOKIES
			}
		},
		{
			text: 'Données personnelles',
			to: {
				name: window.URL_LEGAL_NOTICES,
				hash: window.URL_CGU_PERSONAL_DATA
			}
		},
		{
			text: 'Accessibilité : partiellement conforme',
			href: window.URL_ACCESSIBILITY
		}
	].filter((value) => value.to?.name !== '' && value.href !== '');


return { __sfc: true,linkItems }
}

})